import { Placement } from 'react-joyride';
import { BaseTour } from '../types';

export class PerformanceAssessmentTour extends BaseTour {
  id = 'performance-assessment';

  content = 'Performance Assessment Tour';

  placement: Placement = 'bottom';

  /**
   * Wait for all steps to be registered in the DOM before starting the tour.
   * This page has data-dependent content (service provider combinations from API)
   * that renders after the initial stats load. Without this flag, the tour would
   * auto-start with only 2 steps visible, showing "Finish" prematurely.
   */
  requireAllSteps = true;

  // Disable automatic scrolling - we'll handle it per step
  // disableScrolling = false;

  // Add scroll offset to account for sticky header
  // scrollOffset = 250;

  // Smooth scroll duration
  // scrollDuration = 300;

  // Ensure tour scrolls to first step
  // scrollToFirstStep = true;

  steps = {
    performanceAssessmentPage: () => ({
      content:
        'Welcome to Performance Assessment. This gives you a consolidated view of how all service providers are performing across key financial and operational metrics.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),

    topLevelMetrics: () => ({
      content:
        'These metrics show combined totals across all providers: Amount, Shipments, Invoices, and Charge Lines — each broken down by Before Audit, After Audit, Deviations, and Savings. Percentages are calculated relative to their base: After Audit % is relative to Before Audit, Deviation % is relative to Before Audit, and Savings % is relative to With Deviation.',
      placement: 'top' as Placement,
      disableScrolling: true,
    }),

    serviceProviderAccordion: () => ({
      content: 'Expand any service provider to see the same metrics filtered to that provider only. Each provider section is collapsible for easy navigation.',
      placement: 'top' as Placement,
      disableScrolling: true,
    }),

    quickNavigationLinks: () => ({
      content:
        'From each provider section, quickly navigate to Audit Exceptions to view and resolve flagged invoices, or to Reports & Analytics to generate provider-specific reports.',
      placement: 'top' as Placement,
      disableScrolling: true,
    }),

    monthlyOverviewTable: () => ({
      content:
        'Review 12 months of data per page, including: Total Amount, Deviations, Savings, No. Shipments, No. Invoices, No. Charge Lines, and Audited percentage.',
      placement: 'top' as Placement,
      // scrollOffset: 150,
    }),

    downloadIcon: () => ({
      content: 'Export the monthly overview table as CSV or XLSX using the download icon.',
      placement: 'left' as Placement,
      disableScrolling: true,
    }),
  } as const;
}
